import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import React from 'react';
import RequirementGrid from '../component/RequirementGrid';

const RequirementPage = () => {
  return (
    <>
      <h2 className="TitleGrid">
        <Trans>Requirements</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <RequirementGrid />
    </>
  );
};

export default RequirementPage;
